import styles from "./LCatalogSingleColumnFull.module.css";

/**
 * LCatalogSingleColumnFull — catalog layout 1-kolumnowy w pełnej szerokości okna.
 *
 * **Różnica vs `LCatalogSingleColumn`:** rozszerza się do pełnej szerokości
 * viewport'u (jak nagłówek/stopka), wybijając się z `max-width: 1500px` +
 * `padding: 32px` rodzica `<main>` w `PublicLayoutView`. Trick CSS:
 * `width: 100vw; margin-left: calc(50% - 50vw)` — element renderuje się od
 * lewej krawędzi okna do prawej, niezależnie od kontenera-rodzica.
 *
 * **Struktura (góra -> dół):**
 *   - catalogContent (BLOCKED, content z catalog management)
 *   - belowCatalog (window area)
 */
export function LCatalogSingleColumnFull({
  catalogContent,
  belowCatalog,
}: LCatalogSingleColumnFullProps) {
  return (
    <div className={styles.root}>
      <div className={styles.content}>{catalogContent}</div>
      {belowCatalog ? <div className={styles.below}>{belowCatalog}</div> : null}
    </div>
  );
}

export type LCatalogSingleColumnFullProps = {
  catalogContent: React.ReactNode;
  belowCatalog: React.ReactNode;
};
